'use strict';

import VideoBox from "./VideoBox";

export default class TabSwitcher {
	constructor(className, sp = false) {
		this.rootElement = document.getElementsByClassName(className + "__TabSet")[0];

		let tabContainer = this.rootElement.getElementsByClassName(className + "__Tab")[0];
		this.tabButtons = tabContainer.getElementsByTagName("li");

		this.tabs = [];
		for (let i = 0; i < this.tabButtons.length; i++) {
			let element = this.tabButtons[i];

			let targetName = element.getAttribute("data-target-tab");
			let target = document.getElementById(className + "-" + targetName);

			this.tabs.push({name: targetName, tab: target, box: new VideoBox(target, sp)});

			element.addEventListener("click", event => {
				this.changeTab(element.getAttribute("data-target-tab"));
				this.changeTabButton(element);
			});
		}

		this.changeTab(this.tabButtons[0].getAttribute("data-target-tab"));
	}

	changeTab(tabName) {
		this.tabs.forEach(obj => {
			if (obj.name == tabName) {
				obj.tab.classList.add("-current");
			} else {
				obj.tab.classList.remove("-current");
			}
		});
	}

	changeTabButton(tabButton) {
		for (let i = 0; i < this.tabButtons.length; i++) {
			let element = this.tabButtons[i];
			if (tabButton == element) {
				element.classList.add("-current");
			} else {
				element.classList.remove("-current");
			}
		}
	}
}


// WEBPACK FOOTER //
// ./assets/js/TabContents.js